import Particle from './particle.js';

export default function Orb( config ) {
  Particle.call( this, config );
  this.radius = config.radius || 5;
  this.color = config.color || '#000';
}

Orb.prototype = Object.create( Particle.prototype );

Orb.prototype.draw = function( ctx ) {
  ctx.beginPath();
  ctx.fillStyle = this.color;
  ctx.arc( this.x, this.y, this.radius, 0, Math.PI * 2, false );
  ctx.fill();
};

Orb.prototype.boundaryCheck = function() {
  let W = this.bounds.w;
  let H = this.bounds.h;

  if ( this.x >= W - this.radius ) {
    this.x = W - this.radius;
    this.toggleDirection('x');
  } else if ( this.x <= 0 + this.radius ) {
    this.x = 0 + this.radius;
    this.toggleDirection('x');
  }

  if ( this.y >= H - this.radius ) {
    this.y = H - this.radius;
    this.toggleDirection('y');
  } else if ( this.y <= 0 + this.radius ) {
    this.y = 0 + this.radius;
    this.toggleDirection('y');
  }
};
